import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';

import { GeneralSignalRResponse } from 'src/app/services/signal-r/general-signal-r-response';
import { SignalRService } from 'src/app/services/signal-r/signal-r.service';
import { SignalRAction } from 'src/app/services/signal-r/signalr-enums';
import { Channels } from 'src/app/store/channels';
import { Subscription } from 'rxjs';
import { User } from 'src/app/components/catalogs/user-catalog/services/user';
import { AppStateService } from 'src/app/store/app-state-service';
import { MissingTrainingRefresh } from '../procedure-missing-training/procedure-missing-training.action';
import * as ProcedureConfigurationActions from './procedure-configuration.action';

@Injectable({
  providedIn: 'root'
})
export class ProcedureConfigurationStoreAndListenersService {
  currentUser?: User | null;
  subscription!: Subscription;
  constructor(private store: Store, private signalRService: SignalRService, private ass: AppStateService) { }
  initStore() {
    this.store.dispatch(new ProcedureConfigurationActions.ProcedureConfigurationRefresh());
    this.subscription = this.ass.AppState.subscribe(appState => {
      this.currentUser = appState.currentUser;
    });
  }

  initListeners() {
    this.signalRService.hubConnection?.on(Channels.PROCEDURECONFIGURATION, (data: GeneralSignalRResponse) => {
      this.signalRService.setSender(data.userID);
      switch (data.action) {
        // case SignalRAction.Add:
        //   this.store.dispatch(new ProcedureConfigurationActions.ProcedureConfigurationCreate(data.obj));
        //   break;

        // case SignalRAction.Update:
        //   this.store.dispatch(new ProcedureConfigurationActions.ProcedureConfigurationUpdate(data.id, data.obj));
        //   break;

        // case SignalRAction.Delete:
        //   this.store.dispatch(new ProcedureConfigurationActions.ProcedureConfigurationDelete(data.id));
        //   break;

        case SignalRAction.Get:
          this.store.dispatch(new ProcedureConfigurationActions.ProcedureConfigurationRefresh());
      }
    });

  }
}
